import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VENUES } from '../../../../venues/venues.config';
import { useSelectedVenueId } from '../../../../slices/venue/use-selected-venue';
import { useVenueAvailability } from '../../../../slices/venue/venue-access';
import { selectVenue } from '../../../../slices/venue/select-venue';
import { VenueId } from '../../../../venues/venues.types';
import { paths } from '../../../../routing/path';
import './VenueTabs.scss';

export interface VenueTabsProps {}

export const VenueTabs = (props: VenueTabsProps) => {
    const navigate = useNavigate();
    const dispatch = useDispatch() as any;
    const { pathname } = useLocation();
    const selectedVenueId = useSelectedVenueId();
    const venueAvailability = useVenueAvailability();

    if (pathname === paths.account.venueSelection) {
        return <div className="venue-tabs" />;
    }

    const handleTabClick = (venueId: VenueId) => {
        dispatch(selectVenue(venueId, navigate));
    };

    return (
        <div className="venue-tabs" role="tablist">
            {VENUES.filter(
                (v) => !v.hidden && venueAvailability(v.id) !== 'hidden'
            ).map((venue) => {
                const isActive = venue.id === selectedVenueId;
                const isDisabled = venueAvailability(venue.id) === 'disabled';

                const tabClassName = [
                    'venue-tab',
                    isActive ? 'venue-tab--active' : '',
                    isDisabled ? 'venue-tab--disabled' : '',
                    isActive ? venue.themeClass : '',
                ]
                    .filter(Boolean)
                    .join(' ');

                return (
                    <button
                        key={venue.id}
                        className={tabClassName}
                        onClick={!isDisabled ? () => handleTabClick(venue.id) : undefined}
                        role="tab"
                        aria-selected={isActive}
                        aria-disabled={isDisabled}
                        tabIndex={isDisabled ? -1 : 0}
                        type="button"
                    >
                        <span className="venue-tab__icon-wrapper">
                            <FontAwesomeIcon icon={venue.icon} className="venue-tab__icon" />
                        </span>
                        <span className="venue-tab__label">{venue.label}</span>
                    </button>
                );
            })}
        </div>
    );
};
